/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/react-in-jsx-scope */
import Group from '../../CustomCells/Group/Group';
import './GroupColumn.scss';

const GroupColumn = ({ isOrderByUbication, tieneUbicacionesTecnicas }) => ({
  cellClassName: `group-column-ubication
  ${isOrderByUbication === 'true' ? 'ubication' : 'position'}`,
  component: ({ rowData, rowIndex }) => (
    <Group
      fechasEvento={rowData.fechasEvento}
      firstRowIndex={rowData?.firstRowIndex}
      lastRowIndex={rowData?.lastRowIndex}
      nameLine={rowData?.nameLine}
      namePosition={rowData.namePosition}
      nombreEquipo={rowData.nombreEquipo}
      tipoEvento={rowData.tipoEvento}
      lineBlockedBySap={rowData?.lineBlockedBySap}
      // if the group is PartJobLine, the following prop is required
      numberLine={rowData?.numberLine}
      numberOfLines={rowData?.numberOfLines}
      numberPosition={rowData?.numberPosition}
      rowIndex={rowIndex}
      // if the group is Ubications, the following props are required
      ubicationName={rowData?.ubicationName}
      ubicationFinished={rowData?.ubicationFinished}
      unitMeasurement={rowData?.unitMeasurement}
      hasTechnicalLocations={tieneUbicacionesTecnicas}
      ubicationsData={rowData}
    />
  ),
  disabled: true,
  isCellEmpty: () => true,
  minWidth: 200,
  deleteValue: () => '',
  copyValue: () => '',
  pasteValue: () => ''
});

export default GroupColumn;
